<template>
  <div class="address-tree">
    <address-tree-item
      v-for="attr in items"
      :key="attr.key"

      :attr="attr"

      :name="attr.modelKey"
      :model="model"
      :validateAlias="validateAlias"
      :required="required"
      :tabView="tabView"
      :modalVariableName="modalVariableName"
      :disabled="changeDisabled"
      :onChangeValidation="onChangeValidation"
      :formValidator="formValidator"
      :onValidate="onValidate"
      :placeholder="placeholder"
    ></address-tree-item>
    <e-progress :loading="loading"></e-progress>
    <div class="system-error">{{systemError}}</div>
  </div>
</template>

<script>
  import {core} from "../../api/api-endpoints"
  import userFriendlyEr from '../../utils/userFriendlyEr'
  import AddressTreeItem from "./address-tree-tem";
  import {AddressModel} from "./AddressModel";

  class TreeItem {
    parent_id = ''
    items = []
    key = ''
    skipLoadItems = false

    constructor (key, attr = {}) {
      this.key = key
      for (let k in attr) {
        this[k] = attr[k]
      }
    }
  }

  export class TreeAttributes {

    constructor (modelPrefix = '') {
      this.district = {
        label: 'Район',
        nameKey: 'adrdistrict',
        idKey: 'id',
        modelKey: modelPrefix + 'district_id',
        prefetch: true,
        next: ['cities']
      }
      this.cities = {
        label: 'Город',
        nameKey: 'adrcity',
        idKey: 'id',
        modelKey: modelPrefix + 'city_id',
        next: ['localities'],
        alwaysShown: true
      }
      this.localities = {
        label: 'Населенный пункт',
        nameKey: 'adrlocality',
        idKey: 'id',
        modelKey: modelPrefix + 'locality_id',
        next: ['areas'],
        alwaysShown: true
      }
      this.areas = {
        label: 'Территория',
        nameKey: 'adrarea',
        idKey: 'id',
        modelKey: modelPrefix + 'area_id',
        next: ['streets'],
        alwaysShown: true
      }
      this.streets = {
        label: 'Улица',
        nameKey: 'adrstreet',
        idKey: 'id',
        modelKey: modelPrefix + 'street_id',
        next: ['house'],
        alwaysShown: true
      }
      this.house = {
        label: 'Дом',
        nameKey: 'adrhouse',
        idKey: 'id',
        modelKey: modelPrefix + 'house_id',
        alwaysShown: true
      }
    }
  }

  // data-* attributes used for debug
  export default {
    name: 'address-tree',
    components: {AddressTreeItem},
    data () {
      return {
        systemError: null,
        items: [],
        loading: false
      }
    },
    props: {
      onChangeValidation: {
        type: Boolean,
        default: false
      },
      formValidator: null,
      model: {
        type: Object,
        required: true
      },
      tabView: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null,
        required: true
      },
      validateAlias: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      modalVariableName: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      placeholder: {
        type: String,
        default: null
      },
      onValidate: {
        type: Function,
        default: (obj) => obj
      },
      // ???
      addressData: {
        type: Object,
        required: true,
        default: function () {
          return {}
        }
      },
      treeAttributes: {
        type: Object,
        default: () => (new TreeAttributes())
      }
    },
    computed: {
      changeDisabled () {
        return this.disabled || this.loading
      }
    },
    watch: {
      'treeAttributes': 'init'
    },
    created () {
      this.init()
      if (this.formValidator) {
        this.formValidator.subscribeInput(this)
      }
    },
    destroyed () {
      if (this.formValidator) {
        this.formValidator.unsubscribeInput(this)
      }
    },
    methods: {
      getElement () {
        return null
      },
      init () {
        this.createItemsOnCreateComponent()
        this.updateTree()
        this.attachWatchers()
      },
      attachWatchers () {
        if (this.watchers) {
          this.watchers.forEach(unwatch => unwatch())
        }
        this.watchers = []

        const attributes = this.treeAttributes
        for (let key in attributes) {
          const attr = attributes[key]
          if (!this.model[attr.modelKey]) {
            this.$set(this.model, attr.modelKey, '')
          }
          const unwatch = this.$watch(`model.${attr.modelKey}`, () => {
            this.updateTree(attr.modelKey)
          })
          this.watchers.push(unwatch)
        }
      },
      isEmptyValue (val) {
        return !!(typeof val === "undefined" || val === null || val === '')
      },
      createItemsOnCreateComponent () {
        const attributes = this.treeAttributes
        const nextItems = []
        for (let key in attributes) {
          const attr = attributes[key]

          if (attr.prefetch === true || attr.alwaysShown === true) {
            nextItems.push(new TreeItem(key, attr))
          }
        }

        this.items = nextItems
      },
      updateTree (modelField) {
        if (this.lockUpdates) {
          console.log('update is locked', modelField)
          return
        }
        console.log('caleed updateTree', modelField)
        this.lockUpdates = true

        // reset next values
        let resetNext = false
        this.items.forEach(({modelKey}) => {
          if (resetNext === true) {
            this.model[modelKey] = ''
          }
          if (modelField === modelKey) {
            resetNext = true
          }
        })

        this.saveChangesToAddressData()

        this.buildItems().then(() => {
          this.lockUpdates = false
        }).catch(() => {
          this.lockUpdates = false
        })
      },
      itemIsAdded (items, key) {
        let isAdded = false
        items.forEach(v => {
          if (v.key === key) {
            isAdded = true
          }
        })
        return isAdded
      },
      async buildItems () {
        if (this.loading) {
          return
        }
        this.loading = true
        this.systemError = null
        const nextItems = []
        const attributes = this.treeAttributes
        try {
          // опред требуемую далее структуру данных
          for (let key in attributes) {
            const attr = attributes[key]

            // всегда загружаемые
            if (attr.prefetch === true) {
              nextItems.push(new TreeItem(key, attr))
            }

            // определяем если ли зависимые поля от текущего
            if (attr.next && false === this.isEmptyValue(this.model[attr.modelKey])) {
              attr.next.forEach(nextKey => {
                const treeItem = new TreeItem(nextKey, attributes[nextKey])
                treeItem.parent_id = this.model[attr.modelKey]

                nextItems.push(treeItem)
              })
            }

            // всегда показываемые
            if (attr.alwaysShown === true && this.itemIsAdded(nextItems, key) === false) {
              const ti = new TreeItem(key, attr)
              ti.skipLoadItems = true
              nextItems.push(ti)
            }
          }

          // вгружаем для нее данные
          for (let i = 0; i < nextItems.length; i++) {
            const attr = nextItems[i]
            // загрузка данных
            if (attr.skipLoadItems === false) {
              const {data} = await this.$store.dispatch('updateUrlEndpoint', {
                endpoint: core.address(attr.key, {
                  query: {
                    parent_id: this.isEmptyValue(attr.parent_id) ? null : attr.parent_id
                  }
                }),
                fromCache: true,
                params: {
                  disableGlobalError: true
                }
              })
              nextItems[i].items = data[attr.key]

              // если элементов только один ставим parent_id следующего
              // чтобы подгрузить их в след итерации
              if (data[attr.key].length === 1 && nextItems[i + 1]) {
                const nextIndx = i + 1
                if (this.isEmptyValue(nextItems[nextIndx].parent_id)) {
                  nextItems[nextIndx].skipLoadItems = false
                  nextItems[nextIndx].parent_id = data[attr.key][0][attr.idKey]
                  this.model[attr.modelKey] = data[attr.key][0][attr.idKey]
                }
              }
            } else {
              nextItems[i].items = []
            }

            // create index with duplicates
            const indexByName = {}
            nextItems[i].items.forEach((item) => {
              const name = item[attr.nameKey]
              if(!indexByName.hasOwnProperty(name)) {
                indexByName[name] = {
                  ids: []
                }
              }
              indexByName[name].ids.push(item.id)
            })

            // mark duplicates as: title (id)
            nextItems[i].items.forEach((item, itemIndx) => {
              const indexItem = indexByName[item[attr.nameKey]]
              if (indexItem.ids.length > 1) {
                nextItems[i].items[itemIndx][attr.nameKey] = `${item[attr.nameKey]} (${item[attr.idKey]})`
              }
            })

            // await new Promise(resolve => setTimeout(resolve, 5000))
          }
        } catch (e) {
          this.systemError = userFriendlyEr.recognize(e)
        } finally {
          this.loading = false
        }
        this.items = nextItems
      },
      saveChangesToAddressData () {
        const selectedValues = {}

        const items = this.items
        let values = []
        items.forEach(({modelKey, idKey, items, nameKey}) => {
          for (let i = 0; i < items.length; i++) {
            if (this.model[modelKey] == items[i][idKey]) {
              if (this.isEmptyValue(this.model[modelKey]) === false) {
                // save city titles
                values.push(items[i][nameKey])
                selectedValues[nameKey] = items[i][nameKey]

                // save area_id, city_id, etc...
                selectedValues[modelKey] = this.model[modelKey]
              }
              break
            }
          }
        })

        const data = new AddressModel()
        data.value = values.join(', ')
        data.raw = selectedValues
        data.data.setTree(selectedValues, data.value)

        this.addressData[this.name] = data
        this.model[this.name] = data.value

        this.$emit('selectItem', data)
      },
      validate () {
        let msg = ''

        if (this.required && this.isEmptyValue(this.model[this.name])) {
          msg = 'Укажите значение'
        }

        return this.onValidate({
          error: msg,
          tabView: this.tabView,
          name: this.name,
          modalVariableName: this.modalVariableName,
          el: this.getElement(),
          model: this.model
        })
      }
    }
  }
</script>
